import React from 'react';
import { useNavigate } from 'react-router-dom';
import Icon from '../../../components/AppIcon';
import StatusPill from '../../../components/orizon-ui/StatusPill';

// Classi complete (non interpolate) perché Tailwind le rilevi in fase di build.
const COLORI = {
  blue: {
    barra: 'from-blue-500 to-blue-700',
    icona: 'bg-blue-600/10 text-blue-600 group-hover:bg-blue-600 group-hover:text-white',
    bordo: 'hover:border-blue-500/40 hover:shadow-[0_30px_60px_-15px_rgba(37,99,235,0.2)]',
    testo: 'text-blue-500',
    freccia: 'group-hover:bg-blue-600 group-hover:text-white',
  },
  emerald: {
    barra: 'from-emerald-500 to-emerald-700',
    icona: 'bg-emerald-600/10 text-emerald-600 group-hover:bg-emerald-600 group-hover:text-white',
    bordo: 'hover:border-emerald-500/40 hover:shadow-[0_30px_60px_-15px_rgba(16,185,129,0.15)]',
    testo: 'text-emerald-500',
    freccia: 'group-hover:bg-emerald-600 group-hover:text-white',
  },
  purple: {
    barra: 'from-purple-500 to-purple-700',
    icona: 'bg-purple-600/10 text-purple-600 group-hover:bg-purple-600 group-hover:text-white',
    bordo: 'hover:border-purple-500/40 hover:shadow-[0_30px_60px_-15px_rgba(168,85,247,0.15)]',
    testo: 'text-purple-500',
    freccia: 'group-hover:bg-purple-600 group-hover:text-white',
  },
  orange: {
    barra: 'from-orange-500 to-orange-600',
    icona: 'bg-orange-600/10 text-orange-600 group-hover:bg-orange-600 group-hover:text-white',
    bordo: 'hover:border-orange-500/40 hover:shadow-[0_30px_60px_-15px_rgba(249,115,22,0.15)]',
    testo: 'text-orange-500',
    freccia: 'group-hover:bg-orange-600 group-hover:text-white',
  },
  slate: {
    barra: 'from-slate-500 to-slate-700',
    icona: 'bg-slate-600/10 text-slate-600 group-hover:bg-slate-600 group-hover:text-white',
    bordo: 'hover:border-slate-500/40 hover:shadow-[0_30px_60px_-15px_rgba(100,116,139,0.2)]',
    testo: 'text-slate-500',
    freccia: 'group-hover:bg-slate-600 group-hover:text-white',
  },
};

const SEZIONE_LOGISTICA = [
  { id: 'magazzino', titolo: 'Magazzino', sottotitolo: 'Gestione Articoli', descrizione: 'Giacenze, scorte minime e articoli per reparto.', icona: 'Warehouse', colore: 'blue', percorso: '/gru-magazzino', grande: true },
  { id: 'storico', titolo: 'Storico', sottotitolo: 'Movimenti', descrizione: null, icona: 'History', colore: 'emerald', percorso: '/gru-storico' },
  { id: 'interventi', titolo: 'Interventi', sottotitolo: 'Sostituzioni e Ordini', descrizione: null, icona: 'Wrench', colore: 'purple', percorso: '/gru-interventi' },
];

const SEZIONE_ANALISI = [
  { id: 'statistiche', titolo: 'Statistiche', sottotitolo: 'Analisi per gru e reparto', descrizione: 'Interventi per gru, reparto, anno, articolo e causa.', icona: 'BarChart3', colore: 'orange', percorso: '/gru-statistiche', grande: true },
  { id: 'configurazione', titolo: 'Configurazione', sottotitolo: 'Gru, reparti, codifiche', descrizione: 'Gru, componenti, reparti e campi, cause, magazzini.', icona: 'Settings2', colore: 'slate', percorso: '/gru-configurazione', grande: true },
];

const CardModulo = ({ modulo, onApri }) => {
  const c = COLORI[modulo.colore];
  const attivo = Boolean(modulo.percorso);
  const grande = Boolean(modulo.grande);

  const contenuto = (
    <>
      <div className={`absolute left-0 top-0 bottom-0 w-2 bg-gradient-to-b ${c.barra} ${attivo ? '' : 'opacity-50'}`} />
      <div className={`${grande ? 'p-8 lg:p-10' : 'p-8'} flex flex-col sm:flex-row items-center justify-between w-full gap-6`}>
        <div className="flex items-center gap-5 text-left min-w-0">
          <div className={`${grande ? 'w-16 h-16' : 'w-14 h-14'} rounded-2xl flex items-center justify-center transition-all duration-500 shadow-lg shrink-0 ${c.icona}`}>
            <Icon name={modulo.icona} size={grande ? 32 : 28} />
          </div>
          <div className="min-w-0">
            <h4 className={`${grande ? 'text-3xl' : 'text-xl'} font-black tracking-tighter uppercase leading-none`}>{modulo.titolo}</h4>
            <p className={`${grande ? 'text-[10px]' : 'text-[9px]'} font-black uppercase tracking-widest mt-1 ${c.testo}`}>{modulo.sottotitolo}</p>
          </div>
        </div>

        {modulo.descrizione && (
          <p className="hidden lg:block max-w-[200px] text-[11px] text-muted-foreground font-bold leading-tight opacity-60">
            {modulo.descrizione}
          </p>
        )}

        {attivo ? (
          <div className={`${grande ? 'w-12 h-12' : 'w-10 h-10'} rounded-full bg-muted flex items-center justify-center transition-all shrink-0 ${c.freccia}`}>
            <Icon name="ArrowRight" size={grande ? 20 : 18} />
          </div>
        ) : (
          <StatusPill tono="neutro" label="In arrivo" />
        )}
      </div>
    </>
  );

  if (!attivo) {
    return (
      <div
        aria-disabled="true"
        className={`${grande ? 'md:col-span-2' : ''} relative flex items-center bg-card rounded-[2.5rem] border border-border/40 overflow-hidden opacity-60 cursor-not-allowed select-none`}
      >
        {contenuto}
      </div>
    );
  }

  return (
    <button
      type="button"
      onClick={() => onApri(modulo.percorso)}
      className={`${grande ? 'md:col-span-2' : ''} group relative flex items-center bg-card rounded-[2.5rem] border border-border/40 overflow-hidden transition-all duration-500 ${c.bordo}`}
    >
      {contenuto}
    </button>
  );
};

const GruHomeContent = () => {
  const navigate = useNavigate();

  return (
    <div className="w-full animate-in fade-in slide-in-from-bottom-6 duration-1000 ease-out">
      {/* HEADER */}
      <div className="mb-12">
        <div className="flex items-center gap-3 mb-4">
          <div className="w-10 h-[2px] bg-blue-500 rounded-full" />
          <span className="text-[10px] font-black uppercase tracking-[0.5em] text-blue-500">Reparto Carriponti</span>
        </div>
        <h2 className="text-4xl md:text-6xl font-black tracking-tighter text-foreground">GRU Control Panel</h2>
      </div>

      {/* SEZIONE 1 */}
      <div className="mb-16">
        <h3 className="text-xs font-black uppercase tracking-[0.3em] text-muted-foreground/50 mb-6 px-2">Logistica & Spare Parts</h3>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {SEZIONE_LOGISTICA.map((m) => <CardModulo key={m.id} modulo={m} onApri={navigate} />)}
        </div>
      </div>

      {/* SEZIONE 2 */}
      <div>
        <h3 className="text-xs font-black uppercase tracking-[0.3em] text-muted-foreground/50 mb-6 px-2">Analisi & Impostazioni</h3>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {SEZIONE_ANALISI.map((m) => <CardModulo key={m.id} modulo={m} onApri={navigate} />)}
        </div>
      </div>
    </div>
  );
};

export default GruHomeContent;
